/**
 * Formate la payload d'erreur Django REST / validation en texte lisible.
 * @param {object} errorData
 * @returns {string}
 */
export function formatDjangoValidationErrors(errorData) {
  if (errorData == null || typeof errorData !== 'object') {
    return String(errorData ?? '');
  }
  const errorMessages = [];
  for (const [field, messages] of Object.entries(errorData)) {
    if (Array.isArray(messages)) {
      errorMessages.push(`${field}: ${messages.join(', ')}`);
    } else if (typeof messages === 'string') {
      errorMessages.push(field === 'detail' ? messages : `${field}: ${messages}`);
    }
  }
  return errorMessages.join('\n');
}

/**
 * Construit un résumé sûr d'une erreur Axios pour les logs / la console / les
 * messages utilisateur. Ne renvoie JAMAIS le corps de la requête (config.data),
 * les headers (Authorization), ni le corps de réponse complet (response.data).
 *
 * Utilisation typique dans un `catch` :
 *
 *   } catch (error) {
 *     console.error('Échec création utilisateur:', safeApiError(error));
 *   }
 *
 * @param {unknown} error
 * @returns {{
 *   name: string,
 *   message: string,
 *   code?: string,
 *   method?: string,
 *   url?: string,
 *   status?: number,
 * }}
 */
export function safeApiError(error) {
  const out = {
    name: 'Error',
    message: '[error]',
  };
  if (!error || typeof error !== 'object') {
    out.message = String(error ?? '[error]');
    return out;
  }
  try { if (typeof error.name === 'string') out.name = error.name; } catch (_) {}
  try { if (typeof error.message === 'string') out.message = error.message; } catch (_) {}
  try { if (typeof error.code === 'string') out.code = error.code; } catch (_) {}
  try {
    const cfg = error.config;
    if (cfg) {
      if (cfg.method) out.method = String(cfg.method).toUpperCase();
      if (cfg.url) out.url = String(cfg.url).split('?')[0];
    }
  } catch (_) {}
  try {
    const resp = error.response;
    if (resp && (resp.status || resp.statusCode)) {
      out.status = resp.status || resp.statusCode;
    }
  } catch (_) {}
  return out;
}

/**
 * Variante qui retourne directement une chaîne courte, idéale pour
 * `console.error('contexte:', formatApiError(err))` sans risque de fuite.
 *
 * @param {unknown} error
 * @returns {string}
 */
export function formatApiError(error) {
  const safe = safeApiError(error);
  const parts = [];
  if (safe.method && safe.url) parts.push(`${safe.method} ${safe.url}`);
  if (typeof safe.status === 'number') parts.push(`status=${safe.status}`);
  if (safe.code) parts.push(`code=${safe.code}`);
  parts.push(safe.message);
  return parts.join(' | ');
}
